(() => {
  // app/scripts/common/function/linkOptions.js
  var linkOptions = (container, product, cb) => {
    let optionsMap = {};
    if (!container) {
      return;
    }
    let statusWhenVariantSoldOut = container.dataset.statusSoldOut;
    let optionElements = container.getElementsByClassName("js-option-item");
    if (product.variants.length < 2) {
      return;
    }
    optionElements.addEvents("change", function() {
      container.dispatchEvent(new CustomEvent("swatch-change", { detail: { position: +this.dataset.optionPosition, optionValue: this.value } }));
    });
    container.addEvent("swatch-change", function({ detail: { position, optionValue } }) {
      container.querySelector(`[data-selected-option='option${position}']`).innerHTML = optionValue;
      switch (position) {
        case 1:
          if (product.options.length > 1) {
            updateOptionsInSelector(2);
          } else {
            cb(findVariantFromOption(getValueOptions()));
          }
          break;
        case 2:
          if (product.options.length === 3) {
            updateOptionsInSelector(3);
          } else {
            cb(findVariantFromOption(getValueOptions()));
          }
          break;
        case 3:
          cb(findVariantFromOption(getValueOptions()));
          break;
      }
    });
    product.variants.forEach((variant) => {
      if (variant.available) {
        optionsMap["root"] = optionsMap["root"] || [];
        optionsMap["root"].push(variant.option1);
        optionsMap["root"] = optionsMap["root"].reduce((accu, currentvalue) => {
          if (!accu.includes(currentvalue)) {
            accu.push(currentvalue);
          }
          return accu;
        }, []);
        if (product.options.length > 1) {
          var key = variant.option1;
          optionsMap[key] = optionsMap[key] || [];
          optionsMap[key].push(variant.option2);
          optionsMap[key] = optionsMap[key].reduce((accu, currentvalue) => {
            if (!accu.includes(currentvalue)) {
              accu.push(currentvalue);
            }
            return accu;
          }, []);
        }
        if (product.options.length === 3) {
          var key = variant.option1 + " / " + variant.option2;
          optionsMap[key] = optionsMap[key] || [];
          optionsMap[key].push(variant.option3);
          optionsMap[key] = optionsMap[key].reduce((accu, currentvalue) => {
            if (!accu.includes(currentvalue)) {
              accu.push(currentvalue);
            }
            return accu;
          }, []);
        }
      }
    });
    updateOptionsInSelector(1);
    function updateOptionsInSelector(position) {
      let optionValues = getValueOptions();
      let key, selector;
      switch (position) {
        case 1:
          key = "root";
          selector = container.querySelector(".js-swatch-item[data-position='1']");
          break;
        case 2:
          key = optionValues.option1;
          selector = container.querySelector(".js-swatch-item[data-position='2']");
          break;
        case 3:
          key = optionValues.option1 + " / " + optionValues.option2;
          selector = container.querySelector(".js-swatch-item[data-position='3']");
          break;
      }
      switch (selector.dataset.style) {
        case "select": {
          let selectElement = selector.getElementsByClassName("js-option-item")[0];
          let oldValue2 = selectElement.value;
          switch (statusWhenVariantSoldOut) {
            case "hide": {
              if (Object.keys(optionsMap).length > 0) {
                selectElement.innerHTML = optionsMap[key].map((optionValue) => `<option value="${optionValue}">${optionValue}</option>`).join("");
                if (optionsMap[key].includes(oldValue2)) {
                  selectElement.value = oldValue2;
                }
              } else {
                container.addClass("d-none");
              }
              break;
            }
          }
          break;
        }
        case "color":
        case "image":
        case "button":
          let inputsElement = selector.getElementsByClassName("js-option-item");
          let oldValue = [...inputsElement].find((input) => input.checked).value;
          switch (statusWhenVariantSoldOut) {
            case "hide":
              if (Object.keys(optionsMap).length > 0) {
                inputsElement.forEach((input) => {
                  if (optionsMap[key].includes(input.value)) {
                    input.closest(".swatch-group_wrapper").removeClass("d-none");
                  } else {
                    input.closest(".swatch-group_wrapper").addClass("d-none");
                    oldValue === input.value && (input.checked = false, inputsElement[0].checked = true);
                  }
                });
              } else {
                container.addClass("d-none");
              }
              break;
          }
          break;
      }
      container.dispatchEvent(new CustomEvent("swatch-change", { detail: { position, optionValue: optionValues[`option${position}`] } }));
    }
    function getValueOptions() {
      return [...container.querySelectorAll(".js-swatch-item")].reduce((accu, element) => {
        switch (element.dataset.style) {
          case "select":
            let select = element.querySelector("select.single-option-selector");
            accu[select.name] = select.value;
            break;
          case "color":
          case "image":
          case "button":
            let inputsElements = element.querySelectorAll("input[data-single-option-selector]");
            accu[inputsElements[0].name] = [...inputsElements].find((input) => input.checked).value;
            break;
        }
        return accu;
      }, {});
    }
    function findVariantFromOption(options) {
      return product.variants.find((variant) => {
        return Object.keys(options).every((optionKey) => variant[optionKey] === options[optionKey]);
      });
    }
  };

  // app/scripts/product-page.js
  window.pauseMedia = function(media) {
    if (media.nodeName == "IFRAME") {
      if (media.classList.contains("js-youtube")) {
        media.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', "*");
      }
      if (media.classList.contains("js-vimeo")) {
        media.contentWindow.postMessage('{"method":"pause"}', "*");
      }
    } else if (media.nodeName == "VIDEO") {
      media.pause();
    } else if (media.nodeName == "PRODUCT-MODEL") {
      if (media.modelViewerUI)
        media.modelViewerUI.pause();
    }
  };
  if (!customElements.get("product-container")) {
    class ProductContainer extends HTMLElement {
      constructor() {
        super();
      }
      connectedCallback() {
        let container = this.closest(".shopify-section");
        this.quickView = !!this.closest("popup-quick-view");
        this.featuredProduct = this.classList.contains("section-featured-product");
        if (this.quickView || this.featuredProduct) {
          this.product = JSON.parse(container.querySelector("[data-product-json]").innerHTML);
          this.variantsInventory = JSON.parse(container.querySelector("[data-variants-inventory-json]").innerHTML);
          Object.keys(this.variantsInventory).forEach((variantId) => {
            this.product.variants.find((variant) => variant.id == variantId && Object.assign(variant, this.variantsInventory[variantId]));
          });
        } else {
          this.product = theme.product;
        }
        if (this.product.error)
          return;
        this.elms = {
          mediaMain: container.querySelector(".product-media-main"),
          mediaThumnails: container.querySelector(".product-media-thumnails"),
          saleBadge: container.querySelector(".js-product-label-save"),
          inventoryElement: container.querySelector(".js-inventory"),
          selectMaster: container.querySelector(".js-select-master"),
          addToCartButton: container.querySelector(".js-atc-btn"),
          formElement: container.querySelector("form[action*='/cart/add'].product-form"),
          swatchContainer: container.querySelector("swatch-component"),
          productFormInput: container.querySelector('input[id^="quantity-input"]'),
          subscribeForm: container.querySelector('[id^="contact-notify-when-available"]'),
          pickupAvailability: container.querySelector("pickup-availability"),
          btnPingMe: container.querySelector(".btn-ping-me"),
          taxElement: container.querySelector(".product__tax"),
          wishlistButtons: container.querySelectorAll("wishlist-button button.js-wl"),
          customDots: container.querySelectorAll(".dots-wl-share .js-custom-dots .custom-dots__button"),
          paymentInstallments: container.querySelector(".js-input-master"),
          statusElement: container.querySelector(".js-swatch-status")
        };
        if (container.querySelector("[data-settings]")) {
          this.settings = JSON.parse(container.querySelector("[data-settings]").innerHTML);
        }
        if (!!container.querySelector("[data-header-block]")) {
          this.headerBlockTemplate = container.querySelector("template[data-header-block]").content.firstElementChild.cloneNode(true);
        }
        if (!!container.querySelector("[data-price-block]")) {
          this.priceBlockTemplate = container.querySelector("template[data-price-block]").content.firstElementChild.cloneNode(true);
        }
        this.initSliderMedia();
        this.initInventory();
        this.initFormAddToCart();
        this.initATWL();
        linkOptions(this.elms.swatchContainer, this.product, this.handleVariantChange.bind(this));
        if (!this.elms.swatchContainer) {
          const selectedVariant = this.product.variants.find((variant) => variant.id == +this.dataset.initVariant);
          this.handleVariantChange(selectedVariant);
        }
        if (!this.quickView) {
          if (AT.getParameterByName("contact_posted") || AT.getParameterByName("form_type") == "contact") {
            const subscribeVariantId = JSON.parse(localStorage.getItem("subscribe-variant-id"));
            const _variant = this.product.variants.find((variant) => variant.id == subscribeVariantId);
            if (_variant) {
              if (!this.featuredProduct)
                this.switchVariantById(subscribeVariantId);
              localStorage.removeItem("subscribe-variant-id");
              let searchParams = "";
              if (AT.getParameterByName("contact_posted")) {
                searchParams = window.location.search.replace("?", "").split("&").filter((param) => !param.includes("contact_posted")).filter(Boolean).join("&");
              } else if (AT.getParameterByName("form_type") == "contact") {
                searchParams = window.location.search.replace("?", "").split("&").filter((param) => !param.includes("form_type") && !param.includes("contact%5Bbody%5D=")).filter(Boolean).join("&");
              }
              window.history.replaceState({}, "", `${window.location.pathname}${searchParams && "?".concat(searchParams)}`);
              this.querySelector(".btn-ping-me")?.click();
            }
          }
        }
        if (!this.quickView && !this.featuredProduct) {
          if (AT.getParameterByName("openPingMePopup")) {
            let searchParams = "";
            searchParams = window.location.search.replace("?", "").split("&").filter((param) => !param.includes("openPingMePopup")).filter(Boolean).join("&");
            window.history.replaceState({}, "", `${window.location.pathname}?${searchParams}`);
            this.querySelector(".btn-ping-me")?.click();
          }
          this.saveProductToCookie();
        }
      }
      initSliderMedia() {
        let { mediaMain, mediaThumnails, customDots } = this.elms;
        this.mediaStyle = mediaMain.dataset.style;
        this.mainMediaWatcher = window.matchMedia("(max-width: 767px)");
        requestAnimationFrame(() => {
          this.addEventListener("slider::initialized", (e) => {
            const sliderElement = e.target;
            if (!sliderElement.classList.contains("product-media-main"))
              return;
            this.mainSliderInitialized = true;
          });
          this.mainSlider = mediaMain.init();
          this.thumbnailsSlider = mediaThumnails.init();
          this.mainSlider.events.on("indexChanged", this.onIndexChanged.bind(this));
          if (this.mediaStyle == "stacked") {
            this.lastIndex = 0;
            this.mainMediaWatcher.addEventListener("change", this.onResize.bind(this));
          }
          customDots.forEach((dot, index) => {
            dot.addEventListener("click", (e) => {
              this.mainSlider.goTo(index);
            });
          });
        });
        this.addEventListener("media::active", (e) => {
          this.setProductBadgesVisibility(e.target.closest("[data-media-index]").getAttribute("data-media-index"));
        });
        this.addEventListener("media::deactive", (e) => {
          this.setProductBadgesVisibility(e.target.closest("[data-media-index]").getAttribute("data-media-index"), true);
        });
      }
      onResize(e) {
        this.goToImage(this.lastIndex);
      }
      onIndexChanged(info) {
        const thumbInfo = this.thumbnailsSlider.getInfo();
        const thumbSlideItems = [...thumbInfo.slideItems];
        const thumbActiveSlideItems = thumbSlideItems.filter((item) => item.classList.contains("tns-slide-active"));
        const thumbNavActiveItem = thumbSlideItems.find((item) => item.classList.contains("tns-nav-active"));
        const rangeIndex = thumbActiveSlideItems.indexOf(thumbNavActiveItem);
        if (rangeIndex < 0) {
          this.thumbnailsSlider.goTo(info.index);
        }
        this.elms.customDots.forEach((dot) => dot.classList.remove("custom-dots-active"));
        this.elms.customDots[info.index].classList.add("custom-dots-active");
        if (this.mediaStyle == "stacked") {
          this.lastIndex = info.index;
        }
        this.updateMedia(info.indexCached);
        this.setProductBadgesVisibility(info.index);
      }
      updateMedia(index) {
        const slideItem = this.mainSlider.getInfo().slideItems[index];
        const modelOrVideo = slideItem.querySelector("product-model, .js-vimeo, .js-youtube, video");
        if (modelOrVideo)
          window.pauseMedia(modelOrVideo);
      }
      setProductBadgesVisibility(index, remove = false) {
        const newIndex = parseInt(index);
        const slideItem = this.mainSlider.getInfo().slideItems[newIndex];
        const modelOrVideo = slideItem.querySelector("product-model, deferred-media");
        const isModel = !!slideItem.querySelector("product-model");
        const isActive = modelOrVideo ? isModel ? modelOrVideo.querySelector("model-viewer:not(.shopify-model-viewer-ui__disabled)") : modelOrVideo.classList.contains("show-content") : false;
        if (!modelOrVideo) {
          remove = true;
        }
        if (this.mediaStyle == "stacked") {
          if (this.mainMediaWatcher.matches || newIndex == 0) {
            if (remove) {
              this.querySelector(".product-media")?.classList.remove("media-is-active");
            } else {
              if (isActive) {
                this.querySelector(".product-media")?.classList.add("media-is-active");
              } else {
                this.querySelector(".product-media")?.classList.remove("media-is-active");
              }
            }
          }
        } else {
          if (remove) {
            this.querySelector(".product-media")?.classList.remove("media-is-active");
          } else {
            if (isActive) {
              this.querySelector(".product-media")?.classList.add("media-is-active");
            } else {
              this.querySelector(".product-media")?.classList.remove("media-is-active");
            }
          }
        }
      }
      handleVariantChange(variant) {
        let { selectMaster, paymentInstallments } = this.elms;
        if (!variant) {
          this.currentVariant = null;
          this.setUnavailable();
          return;
        }
        this.currentVariant = variant;
        this.updateProductBadges(variant);
        this.updatePickupAvailability(variant);
        this.updateProductCodes(variant);
        this.updateAddToCartButton(variant);
        this.updateInventory(variant);
        this.updatePrice(variant);
        this.updateTaxInformation(variant);
        this.setLiveRegionText(variant);
        if (!this.quickView && !this.featuredProduct)
          this.updateURLHash(variant);
        if (!!variant.featured_media) {
          requestAnimationFrame(() => {
            if (this.mediaStyle == "carousel") {
              if (this.mainSlider.isOn) {
                this.mainSlider.goTo(variant.featured_media.position - 1);
              } else {
                if (this.mainSliderInitialized) {
                  this.mainSlider.goTo(variant.featured_media.position - 1);
                } else {
                  this.addEventListener("slider::initialized", () => {
                    this.mainSlider.goTo(variant.featured_media.position - 1);
                  });
                }
              }
            } else {
              this.goToImage(variant.featured_media.position - 1);
            }
          });
        }
        if (selectMaster)
          selectMaster.value = variant.id;
        if (paymentInstallments) {
          paymentInstallments.value = variant.id;
          paymentInstallments.dispatchEvent(new Event("change", { bubbles: true }));
        }
      }
      setLiveRegionText(variant) {
        const { statusElement } = this.elms;
        if (!statusElement)
          return;
        let statusText = "";
        if (variant) {
          if (!variant.available) {
            if (variant.title.toLowerCase().includes("default title")) {
              statusText = theme.strings.product.soldOut;
            } else {
              statusText = theme.strings.product.variantSoldOut.replace("[variant]", variant.title);
            }
          }
        } else {
          statusText = theme.strings.product.variantUnavailable;
        }
        if (statusText == "")
          return;
        statusElement.setAttribute("aria-hidden", "false");
        statusElement.textContent = "";
        setTimeout(() => {
          statusElement.textContent = statusText;
        }, 10);
        setTimeout(() => {
          statusElement.setAttribute("aria-hidden", "true");
        }, 1e3);
      }
      goToImage(index) {
        this.lastIndex = index;
        if (this.mainMediaWatcher.matches) {
          if (this.mainSlider.isOn) {
            this.mainSlider.goTo(index);
          } else {
            if (this.mainSliderInitialized) {
              this.mainSlider.goTo(index);
            } else {
              this.addEventListener("slider::initialized", () => {
                this.mainSlider.goTo(index);
              });
            }
          }
        } else {
          const scrollTarget = this.mainSlider.getInfo().slideItems[index];
          let scrollDuration = 1e3;
          let sliderHeight = this.mainSlider.getInfo().container.closest("slider-component").offsetHeight;
          if (sliderHeight > 5e3) {
            scrollDuration = 1500;
          }
          requestAnimationFrame(() => {
            AT.scrollTo(scrollTarget, scrollDuration);
          });
        }
      }
      setUnavailable() {
        this.updatePickupAvailability();
        this.updateProductCodes();
        this.updateAddToCartButton();
        this.updateInventory();
        this.updatePrice();
        this.updateTaxInformation();
        this.setLiveRegionText();
      }
      updateTaxInformation(variant) {
        let { taxElement } = this.elms;
        if (!taxElement)
          return;
        if (!variant) {
          taxElement.closest(".product__tax").addClass("d-none");
          return;
        }
        taxElement.closest(".product__tax").removeClass("d-none");
      }
      updateProductCodes(variant) {
        if (!this.headerBlockTemplate)
          return;
        const id = !!variant ? variant.id : "unavailable";
        const newDOM = this.headerBlockTemplate.querySelector(`.variant-template[data-variant-id="${id}"]`);
        this.querySelector(".product__codes").innerHTML = newDOM.querySelector(".product__codes").innerHTML;
      }
      updatePickupAvailability(variant) {
        let { pickupAvailability } = this.elms;
        if (!pickupAvailability || !pickupAvailability.update)
          return;
        pickupAvailability.update(variant);
      }
      initInventory() {
        let { inventoryElement } = this.elms;
        this.inventory = {
          setStatus: (status, variant) => {
            if (!this.settings.showInventory || !inventoryElement)
              return;
            inventoryElement.setAttribute("data-status", status);
            switch (status) {
              case "low-stock-show-count": {
                inventoryElement.querySelector(".js-inventory__low-stock-show-count").innerHTML = theme.strings.product.lowStockShowCount.replace("{{quantity}}", variant.inventory_quantity);
                break;
              }
              case "in-stock-show-count": {
                inventoryElement.querySelector(".js-inventory__in-stock-show-count").innerHTML = theme.strings.product.inStockShowCount.replace("{{quantity}}", variant.inventory_quantity);
                break;
              }
            }
          }
        };
      }
      updateSubscribeForm(variant) {
        let { subscribeForm } = this.elms;
        if (!subscribeForm)
          return;
        let inputBody = subscribeForm.querySelector("input[name='contact[body]']");
        if (AT.getParameterByName("contact_posted")) {
          subscribeForm.querySelector(".popup__form-inner").removeClass("posting_failed");
        } else if (AT.getParameterByName("form_type") == "contact") {
          subscribeForm.querySelector(".popup__form-inner").removeClass("posted-successfully");
        } else {
          subscribeForm.querySelector(".popup__form-inner").removeClass("posting_failed");
          subscribeForm.querySelector(".popup__form-inner").removeClass("posted-successfully");
        }
        inputBody.value = inputBody.dataset.value.replace("{{product_name}}", variant.name);
        subscribeForm.addEvent("submit", () => {
          localStorage.setItem("subscribe-variant-id", JSON.stringify(this.currentVariant.id));
        });
      }
      updateAddToCartButton(variant) {
        let { addToCartButton } = this.elms;
        if (!addToCartButton)
          return;
        if (!variant) {
          addToCartButton.disabled = true;
          addToCartButton.querySelector("span").innerHTML = theme.strings.product.unavailable;
          this.toggleProductInfo();
          return;
        }
        if (variant.available) {
          addToCartButton.disabled = false;
          addToCartButton.querySelector("span").innerHTML = theme.strings.product.addToCart;
          this.toggleProductInfo(false);
        } else {
          addToCartButton.disabled = true;
          addToCartButton.querySelector("span").innerHTML = theme.strings.product.soldOut;
          this.toggleProductInfo();
        }
      }
      toggleProductInfo(hide = true) {
        const selectors = [".product__form-quantity", ".product__form-dynamic-checkout", ".product__custom-option"].join(", ");
        this.querySelectorAll(selectors).forEach((element) => hide ? element.addClass("d-none") : element.removeClass("d-none"));
      }
      updateInventory(variant) {
        if (!variant) {
          this.inventory.setStatus("out-stock");
          return;
        }
        if (variant.available) {
          if (variant.inventory_management) {
            if (variant.inventory_policy == "continue" && variant.inventory_quantity < 1) {
              this.inventory.setStatus("in-stock");
            } else {
              if (!!this.settings.inventoryQuantity) {
                variant.inventory_quantity <= this.settings.inventoryThreshold ? this.inventory.setStatus("low-stock-show-count", variant) : this.inventory.setStatus("in-stock", variant);
              } else {
                variant.inventory_quantity <= this.settings.inventoryThreshold ? this.inventory.setStatus("low-stock", variant) : this.inventory.setStatus("in-stock", variant);
              }
            }
          } else {
            this.inventory.setStatus("in-stock");
          }
        } else {
          this.inventory.setStatus("out-stock");
        }
      }
      initFormAddToCart() {
        let { formElement, addToCartButton } = this.elms;
        if (!formElement || !addToCartButton)
          return;
        if (document.querySelector("cart-drawer"))
          addToCartButton.setAttribute("aria-haspopup", "dialog");
        formElement.addEvent("submit", (e) => {
          e.preventDefault();
          if (addToCartButton.getAttribute("aria-disabled") === "true")
            return;
          addToCartButton.setAttribute("aria-disabled", true);
          if (!addToCartButton.querySelector(".svg-loading")) {
            addToCartButton.insertAdjacentHTML("beforeend", '<svg class="svg-loading" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" style="margin: auto; background: none; shape-rendering: auto;" width="28px" height="28px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid"><circle cx="50" cy="50" fill="none" stroke="currentColor" stroke-width="5" r="35" stroke-dasharray="164.93361431346415 56.97787143782138">  <animateTransform attributeName="transform" type="rotate" repeatCount="indefinite" dur="1s" values="0 50 50;360 50 50" keyTimes="0;1"></animateTransform></circle></svg>');
          }
          addToCartButton.addClass("has-pending");
          window.Cart.add(formElement).then((cart) => {
            this.querySelector("recipient-form")?.resetRecipientForm();
          }).catch((error) => {
            console.log("error::", error);
            if (!!this.querySelector("recipient-form") && typeof error.description == "object") {
              this.querySelector("recipient-form").displayErrorMessage(error.description);
            } else {
              AT.loadPopupMessage().then(() => {
                window.Popups.closeAll();
                window.PopupMessage.open(error.description || error.message);
              });
              fetch(theme.routes.cartGet, { dataType: "json" }).then((res) => {
                if (res.item_count > window.Cart.cart.item_count) {
                  window.Cart.cart = res;
                  fetch(window.Shopify.routes.root + `cart?sections=${window.Cart.getSectionsToRender().join(",")}`, {
                    dataType: "json"
                  }).then((sections) => {
                    const newRes = Object.assign(res, { sections, isError: true });
                    document.dispatchEvent(new CustomEvent("cart-add", { detail: newRes }));
                    document.dispatchEvent(new CustomEvent("cart-change", { detail: newRes }));
                  });
                }
              });
            }
          }).finally(() => {
            addToCartButton.removeClass("has-pending");
            addToCartButton.removeAttribute("aria-disabled");
          });
        });
      }
      updateProductBadges(variant) {
        let { saleBadge } = this.elms;
        if (!saleBadge)
          return;
        let percentElement = saleBadge.querySelector(".js-percent");
        let moneySaved = saleBadge.querySelector(".js-money-saved");
        let { compare_at_price, price } = variant;
        if (compare_at_price > price) {
          moneySaved.innerHTML = (compare_at_price - price).toCurrency();
          percentElement.innerHTML = Math.round((compare_at_price - price) / compare_at_price * 100);
          saleBadge.removeClass("d-none");
        } else {
          saleBadge.addClass("d-none");
        }
      }
      updatePrice(variant) {
        if (!variant) {
          this.querySelector(".product__price").addClass("d-none");
          return;
        }
        if (!this.priceBlockTemplate)
          return;
        const id = !!variant ? variant.id : "unavailable";
        const newDOM = this.priceBlockTemplate.querySelector(`.variant-template[data-variant-id="${id}"]`);
        this.querySelector(".product__price__wrapper").innerHTML = newDOM.querySelector(".product__price__wrapper").innerHTML;
        this.querySelector(".product__price").removeClass("d-none");
      }
      updateURLHash(variant) {
        let searchParams = window.location.search.replace("?", "").split("&").filter(Boolean);
        window.history.replaceState({}, "", AT.getParameterByName("variant") ? `${window.location.pathname}?${searchParams.map((param) => param.includes("variant") ? "variant=" + variant.id : param).join("&")}` : (searchParams.unshift("variant=" + variant.id), `${window.location.pathname}?${searchParams.join("&")}`));
      }
      switchVariantById(variantId) {
        let { swatchContainer } = this.elms;
        let variantFound = theme.product.variants.find((i) => i.id == variantId);
        if (!variantFound) {
          return;
        }
        variantFound.options.forEach((option, index) => {
          [...swatchContainer.querySelectorAll(`[name='option${index + 1}']`)].find((element) => {
            switch (element.tagName) {
              case "INPUT":
                element.value == option && (element.checked = true, element.dispatchEvent(new Event("change")));
                break;
              case "SELECT":
                element.value = option;
                element.dispatchEvent(new Event("change"));
                break;
            }
          });
        });
      }
      saveProductToCookie() {
        let currentProductHandle = theme.product.handle;
        let productHandleArray = JSON.parse(localStorage.getItem("recently-viewed-products")) || [];
        if (productHandleArray.length) {
          !productHandleArray.includes(currentProductHandle) && productHandleArray.unshift(currentProductHandle);
          productHandleArray.length = 10;
        } else {
          productHandleArray.unshift(currentProductHandle);
        }
        localStorage.setItem("recently-viewed-products", JSON.stringify(productHandleArray.filter(Boolean)));
      }
      initATWL() {
        const { wishlistButtons } = this.elms;
        if (!wishlistButtons.length)
          return;
        wishlistButtons.forEach((wishlistButton) => {
          const { productTitle, productHandle, productImage, productImageRatio, productImagePadding } = wishlistButton.dataset;
          const product = {
            title: productTitle,
            handle: productHandle,
            image: productImage,
            imageRatio: productImageRatio,
            imagePadding: productImagePadding
          };
          if (window.Wishlist.wishlist.includes(product.handle)) {
            wishlistButton.classList.add("is-added");
            wishlistButton.setAttribute("aria-label", wishlistButton.getAttribute("data-remove-from-wishlist"));
            wishlistButton.setAttribute("title", wishlistButton.getAttribute("data-remove-from-wishlist"));
          } else {
            wishlistButton.setAttribute("aria-label", wishlistButton.getAttribute("data-add-to-wishlist"));
            wishlistButton.setAttribute("title", wishlistButton.getAttribute("data-add-to-wishlist"));
          }
          wishlistButton.addEventListener("click", (e) => {
            const target = e.target;
            if (target.classList.contains("is-added")) {
              window.Wishlist.remove(product);
              window.Wishlist.showPopup(product, false);
            } else {
              window.Wishlist.add(product);
              window.Wishlist.showPopup(product);
            }
            document.querySelectorAll(`button.js-wl[data-product-handle="${product.handle}"]`).forEach((button) => {
              button.classList.toggle("is-added");
              if (button.classList.contains("is-added")) {
                button.setAttribute("aria-label", button.getAttribute("data-remove-from-wishlist"));
              } else {
                button.setAttribute("aria-label", button.getAttribute("data-add-to-wishlist"));
              }
            });
          });
        });
      }
    }
    customElements.define("product-container", ProductContainer);
    console.log("product-page.js loaded");
    console.log("1");
  }
})();
